import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const GlobalConfiguartionServiceRequestComponent = ({ periods,chosenServiceRequest, handleInnerFormChange}: any) => {

    return (
        <>
   <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="Duration"
                          labelField="Duration"
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'TimeToResolve.Duration',
                              chosenServiceRequest?.TimeToResolve,
                            );
                          }}
                          type="number"
                          value={
                            chosenServiceRequest?.TimeToResolve?.Duration
                          }
                        />
                     
                        <InputContainer
                          label="Duration Unit"
                          labelField="Text"
                          list={periods}
                          onValueChange={(event: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'TimeToResolve.DurationUnitId',
                              chosenServiceRequest?.TimeToResolve,
                            );
                          }}
                          optionName='Choose Duration Unit'
                          type="select"
                          value={
                            chosenServiceRequest?.TimeToResolve?.DurationUnitId
                          }
                          valueField="Value"
                        />
                      </div>
                  }
                  expandedPanel="ServiceRequest Info"
                  headerTitle="ServiceRequest Info"
                />
    </>
  )
}
export default GlobalConfiguartionServiceRequestComponent;
